'use client';
import { useTranslations } from 'next-intl';
import useCompany from '@/app/hooks/useCompany';
import Image from 'next/image';
import Accordion from '@/app/components/ui-elements/accordion';
import Staff from './Staff';

const services = [
    {
        title: "service_1_title",
        desc: "service_1_desc"
    },
    {
        title: "service_2_title",
        desc: "service_2_desc"
    },
    {
        title: "service_3_title",
        desc: "service_3_desc"
    },
    {
        title: "service_4_title",
        desc: "service_4_desc"
    }
];

export default function Services() {
    const t = useTranslations('About');
    const { company } = useCompany();

    return (
        <div className='mb-0 md:mb-10 mt-4 md:mt-10 px-4 md:px-20 text-start'>
            <div className='flex flex-col md:flex-row justify-start items-center'>
                <div className='flex-1 flex flex-row md:flex-col justify-center gap-6 md:gap-0 md:justify-start items-center md:items-start w-full md:w-auto'>
                    <div className='md:pb-10'>
                        <Image
                            src={'/images/about/icon1.png'}
                            width={90}
                            height={90}
                            alt={`windows icon`}
                            className="max-w-16 md:max-w-none mx-auto md:mx-0 h-auto md:ps-6"
                        />
                        <h3 className='text-md md:text-2xl mt-2 color-primary leading-none text-center md:text-start md:ps-8'>
                            {t('windows')}
                        </h3>
                    </div>
                    <div className='md:pb-10 md:pt-10'>
                        <Image
                            src={'/images/about/icon2.png'}
                            width={90}
                            height={90}
                            alt={`restoration icon`}
                            className="max-w-16 md:max-w-none mx-auto md:mx-0 h-auto md:ps-6"
                        />
                        <h3 className='text-md md:text-2xl mt-2 color-primary leading-none text-center md:text-start md:ps-8'>
                            {t('restoration')}
                        </h3>
                    </div>
                    <div className='md:pb-10 md:pt-10'>
                        <Image
                            src={'/images/about/icon3.png'}
                            width={90}
                            height={90}
                            alt={`woodworking icon`}
                            className="max-w-16 md:max-w-none mx-auto md:mx-0 h-auto md:ps-6"
                        />
                        <h3 className='text-md md:text-2xl mt-2 color-primary leading-none text-center md:text-start md:ps-8'>
                            {t('woodworking')}
                        </h3>
                    </div>
                </div>
                <div className='flex-2'>
                    <div className='md:pb-16'>
                        <h2 className='text-sm md:text-lg color-primary font-semibold md:max-w-xs leading-none mt-4'>
                            {t('our_company')}
                        </h2>
                        <h2 className='text-xl md:text-4xl leading-none text-start mt-2'>
                            {t('our_vision')}
                        </h2>
                        <h2 className='text-sm md:text-lg leading-normal mt-6'>
                            {t('about1')}
                        </h2>
                        <h2 className='text-sm md:text-lg leading-normal mt-6'>
                            {t('about2')}
                        </h2>
                    </div>
                        <div className='pe-2 md:pe-10 mt-2'>
                            {services?.map((service: any, index: number) => (
                                <Accordion title={t(service?.title)} defaultOpen={index==0} key={index}>
                                    <h2 className='text-sm md:text-[16px] leading-none'>
                                        {t(service?.desc)}
                                    </h2>
                                </Accordion>
                            ))}
                        </div>
                </div>
            </div>
            <div className='flex flex-col md:flex-row justify-start mt-10'>
                <div className='flex-1 mb-10'>
                        <h1 className='text-xl md:text-5xl leading-none text-start uppercase mt-4'>
                           {company?.id}{" "}{t('team')}
                        </h1>
                </div>
                <div className='flex-2 border-l-1 border-slate-100'>
                    <Staff />
                </div>
            </div>
        </div>
    );
}
